// test9
(9 && 0);
